<template>
	<div ref="scrollContainer" id="page-panel" >
    <resize-observer @notify="__resizeHanlder" />
		<div class="customer-top-nav no-print">
			<div class="title">
				<span>{{$t('invoices.invoicesTitle')}}</span>
			</div>
			<div class="controls">
				<el-radio-group v-model="modeModel" class="hidden-sm-and-down" size="small">
					<el-radio-button label="list" style="padding:5px 0px 5px 0px;"><i class="mdi mdi-view-list" style="font-size:12px;"></i></el-radio-button>
					<el-radio-button label="tile" style="padding:5px 0px 5px 0px;"><i class="mdi mdi-view-grid" style="font-size:12px;"></i></el-radio-button>
				</el-radio-group>
				 <el-button type="primary" @click="openInvoiceEditor" size="small" :disabled="!$can('write', 'Invoices')"><i class="mdi mdi-plus-circle"><span style="padding-left:5px;">{{$t('common.New')}}</span></i> </el-button>
			</div>
		</div>
    <el-row>
      <el-col :span="leftPanelSpan"  >
        <InvoicesList @select="showInvoice" @new="openInvoiceEditor"></InvoicesList>
			</el-col>
      <el-col :span="rightPanelSpan" v-if="showRightPanel" style="padding-left:10px;">
        <InvoiceView @close="closeSelectedInvoice" @edit="editInvoice" :invoice="this.selectedInvoice"></InvoiceView>
			</el-col>
    </el-row>
		<InvoiceEditor :visible="invoiceEditorVisible" :editInvoice="editSelectedInvoice" @close="closeInvoiceEditor" @created="invoiceCreated"></InvoiceEditor>
	</div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import InvoiceEditor from '@/components/invoice/invoice-editor'
import InvoicesList from './components/invoices-list'
import InvoiceView from './components/invoice-view'

// import SalesOrdersView from './components/sales-order-view'

export default {
  data() {
    return {
      leftPanelSpan : 24,
      pageWidth : 0,
			pageHeight : 0,
      rightPanelSpan:0,
      showRightPanel:false,
      search : '',
      invoiceDialogVisible : false,
			editSelectedInvoice : null,
			invoiceEditorVisible: false,
    };
  },components: {
    InvoiceEditor,
		InvoicesList,
		InvoiceView
  },
  watch : {

  },
	methods: {
		invoiceCreated(){
			  this.invalidateInvoiceList();
				this.fetchInvoices();
		},
		closeInvoiceEditor(){
			this.invoiceEditorVisible = false;
			this.editSelectedInvoice = null;
		},
		openInvoiceEditor(){
			this.invoiceEditorVisible = true;
		},
		editInvoice(){
			this.editSelectedInvoice = this.selectedInvoice;
			this.openInvoiceEditor();
		},
		showInvoice(index){
			this.selectInvoice({index});
			if(this.pageWidth<1054){
        this.leftPanelSpan=0;
        this.rightPanelSpan = 24;
      }else{
        this.leftPanelSpan=8;
        this.rightPanelSpan=16;
      }
			this.showRightPanel=true;
		},
		closeSelectedInvoice(){
			this.rightPanelSpan=0;
      this.leftPanelSpan=24;
      this.showRightPanel=false;
		},
    close(){
			this.$router.go(-1);
		},
		setPageWidth() {
			this.pageWidth = document.getElementById('page-panel').offsetWidth;
			this.pageHeight = document.getElementById('page-panel').offsetHeight;
		},
    __resizeHanlder: _.throttle(function (e) {
			this.setPageWidth();
		}, 700),
		 ...mapActions('invoices', [ 'fetchInvoices','selectInvoice','invalidateInvoiceList','changeMode']),
		 ...mapActions('statuses',['fetchInvoiceStatuses'])
	},
	computed: {
		modeModel : {
			get(){ return this.mode},
			set(mode){this.closeSelectedInvoice();this.changeMode(mode)}
		},
		...mapState('invoices', [ 'invoices', 'selectedInvoice','mode']),
	},
  mounted(){
    this.setPageWidth();

  },
	created(){
		this.fetchInvoices();
		this.fetchInvoiceStatuses();
	}
}
</script>
<style lang="scss" scoped>
@import '../../../assets/scss/_variables';

.title {
	font-size : 1.6em;
	font-weight:bold;
	margin-right:20px;
	position:relative;
	float:left;
}
.customer-top-nav{
  height:80px;
}

.controls{
	position:relative;
	float:right;

	button{
		margin-left:20px;
	}
}

.el-table tr, .el-table__row{
  background-color: #f3f7fa;
}


@media (max-width: 1024px) {
  img.inventory {
    margin-top:20px;
    height:175px;
  }
}
</style>
